/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const dummyContents = {
  user: {
    name: 'Ahmed Mansour',
    title: 'Company Admin',
    avatar: 'http://via.placeholder.com/100x100/00BCD4/FFFFFF/',
    status: 'key1',
  },
  text: {
    title: 'Any Title',
    subtitle: 'Property status is updated.',
    subtitleProp: 'Property status is updated.',
    account_sentence: 'Your account is not upgraded.',
    date: 'May 31, 2021',
  },
};

export default dummyContents;
